import { dictionary as ptBr } from "./pt_br";

export const dictionary = {
  pt_BR: ptBr,
};
